import {
  FETCH_COMPANY_REQUEST,
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_ERROR,
  UPDATE_DEVICE_COMPANY_REQUEST,
  UPDATE_DEVICE_COMPANY_ERROR,
} from "./actions";
import { REDUCERS } from "../../common/constants";
import { createReducer } from "../../common/helpers";

const schema = {
  loading: false,
  error: false,
  success: false,
  totalElements: 0,
  companyList: [],
  companyDetail: {
    loading: false,
    error: false,
    data: {},
  },
};

const reducer = {
  [FETCH_COMPANY_REQUEST]: (state) => {
    return {
      ...state,
      ...REDUCERS.LOADING,
      success: false,
      companyDetail: {
        loading: false,
        error: false,
        data: {},
      },
    };
  },
  [FETCH_COMPANY_SUCCESS]: (state, { payload }) => {
    const userDetails = JSON.parse(localStorage.getItem("user-details"));
    const notTenent = userDetails.roles.find(
      (val) =>
        val.role === "SupplierAdmin" ||
        val.role === "SupplierUser" ||
        val.role === "PracticeUser"
    );
    let count = payload.totalElements;
    let content = payload.content;
    if (notTenent) {
      count = 1;
      content = payload.content.filter(
        (val) => val.supplierId === userDetails.roles[0].supplier.supplierId
      );
    }
    return {
      ...state,
      ...REDUCERS.SUCCESS,
      success: false,
      totalElements: count,
      companyList: content.sort((a, b) => (a.name > b.name ? 1 : -1)),
    };
  },
  [FETCH_COMPANY_ERROR]: (state) => ({
    ...state,
    ...REDUCERS.ERROR,
  }),
  [UPDATE_DEVICE_COMPANY_REQUEST]: (state) => ({
    ...state,
    ...REDUCERS.LOADING,
  }),
  [UPDATE_DEVICE_COMPANY_ERROR]: (state) => ({
    ...state,
    ...REDUCERS.ERROR,
  }),
};

export default createReducer(schema, reducer);
